import { motion } from 'framer-motion';

export interface TabItem {
  id: string;
  label: string;
  icon?: React.ComponentType<{ className?: string }>;
}

/**
 * Animated Tabs（Aceternity UI 风格）— 高亮背景在标签间平滑滑动
 */
export function AnimatedTabs({
  tabs,
  active,
  onChange,
  className = '',
  size = 'md',
}: {
  tabs: TabItem[];
  active: string;
  onChange: (id: string) => void;
  className?: string;
  size?: 'sm' | 'md';
}) {
  const pad = size === 'sm' ? 'px-3 py-1.5 text-xs' : 'px-4 py-2 text-sm';
  return (
    <div className={`inline-flex items-center gap-1 p-1 rounded-xl bg-card/70 border border-border-soft ${className}`}>
      {tabs.map((tab) => {
        const isActive = active === tab.id;
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`relative flex items-center gap-1.5 rounded-lg font-semibold transition-colors duration-200 ${pad} ${isActive ? 'text-white' : 'text-text-muted hover:text-text'}`}
          >
            {isActive && (
              <motion.span
                layoutId={`tab-pill-${tabs.map((t) => t.id).join('-')}`}
                transition={{ type: 'spring', stiffness: 400, damping: 32 }}
                className="absolute inset-0 brand-gradient rounded-lg glow-primary"
              />
            )}
            {Icon && <Icon className="relative z-10 w-4 h-4" />}
            <span className="relative z-10">{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}
